import Widget from '../Widget/Widget';
import { computed, Ref, ref } from 'vue';
import { OnMounted } from '@studyportals/vue-platform';

export default class ButtonEssentialInfo extends Widget implements OnMounted {
	private tag: Ref<HTMLElement | null> = ref(null);

	private hasScore = computed((): boolean => {
		if (this.isFullProfile.value && this.bestFitScore.value) {
			return true;
		}
		return false;
	});

	private fitText = computed((): string => {
		if (this.hasScore.value) {
			return `${this.displayScore.value}`;
		}
		if (this.emptyText !== null) {
			return this.emptyText;
		}

		return '';
	});

	mounted(): void {
		this.waitForSession();
	}
}
